import React from 'react';
import {useMenu} from '../../../hooks/useMenu';
import ProgressBarView from '../../views/progressbarView';
import ProvingTN from './provingTN';

function ProvingPB() {
  const {onComponent} = useMenu();
  return (
    <ProgressBarView
      title="Saving Configuration"
      content="Saving backup configuration file..."
      onExit={() => onComponent(<ProvingTN />)}
    />
  );
}

export default ProvingPB;
